var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentMethodAch = function SvgPaymentMethodAch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.863 8.73961H27V15.6604H25.863V12.6647H22.897V15.6604H21.76V8.73961H22.897V11.5771H25.863V8.73961Z",
    fill: "#363840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8393 15.7889C16.7979 15.7889 15.9344 15.4462 15.2489 14.7607C14.5634 14.0686 14.2207 13.215 14.2207 12.2C14.2207 11.185 14.5634 10.3347 15.2489 9.6492C15.9344 8.95712 16.7979 8.61108 17.8393 8.61108C18.4654 8.61108 19.0422 8.75938 19.5695 9.05599C20.1034 9.35259 20.5186 9.75466 20.8152 10.2622L19.8265 10.8356C19.642 10.4929 19.3717 10.2226 19.0158 10.0249C18.6665 9.82057 18.2743 9.71841 17.8393 9.71841C17.1011 9.71841 16.5013 9.95239 16.0399 10.4204C15.5851 10.8883 15.3577 11.4816 15.3577 12.2C15.3577 12.9184 15.5851 13.5116 16.0399 13.9796C16.5013 14.4476 17.1011 14.6816 17.8393 14.6816C18.2743 14.6816 18.6698 14.5827 19.0257 14.385C19.3816 14.1807 19.6486 13.9071 19.8265 13.5644L20.8152 14.1279C20.5252 14.6355 20.1132 15.0408 19.5794 15.344C19.0521 15.6406 18.472 15.7889 17.8393 15.7889Z",
    fill: "#363840"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8573 15.6604L12.3729 14.2663H9.42661L8.94215 15.6604H7.7063L10.2176 8.73961H11.5819L14.0833 15.6604H12.8573ZM9.8023 13.1986H11.9972L10.8997 10.0743L9.8023 13.1986Z",
    fill: "#363840"
  })));
};
export default SvgPaymentMethodAch;